import { useEffect, useState } from "react";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import LoadingWheel from "../../components/shared/LoadingWheel";
import useMaterials from "../../data/useMaterials";
import { IMaterial } from "../../models/Material";
import MaterialsModal from "../../components/materials/MaterialsModal";
import MaterialsTable from "../../components/materials/MaterialsTable";

export default function MaterialManager() {
  const { setInfo } = usePageNameContext();
  const { materials: allMaterials } = useMaterials();
  const [materials, setMaterials] = useState<IMaterial[] | undefined>(undefined);
  const [editMaterial, setEditMaterial] = useState<IMaterial | undefined>(undefined);

  const [isLoading, setIsLoading] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Material Manager",
      desc: "View and edit material records",
    });
  }, []);

  useEffect(() => {
    if (!allMaterials.isLoading && allMaterials.data) {
      setMaterials(allMaterials.data?.data);
      setIsLoading(false);
    }
  }, [allMaterials.isLoading, allMaterials.data]);

  const handleSetMaterial = (material: IMaterial) => {
    setEditMaterial(material);
    setCreateOpen(true);
  };

  const handleAddMaterial = () => {
    setEditMaterial(undefined);
    setCreateOpen(true);
  };

  return allMaterials.isLoading || isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <MaterialsModal open={createOpen} setOpen={setCreateOpen} material={editMaterial} />
      <div className="mt-4 flex justify-between">
        <button
          className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
          type="button"
          onClick={() => handleAddMaterial()}
        >
          <PlusSmallIcon className="h-5 w-5 mr-2" />
          Add New Material
        </button>
      </div>
      <MaterialsTable materials={materials!} setMaterial={handleSetMaterial} />
    </>
  );
}
